import { InvalidColorException } from '../utils/exceptions/invalid-color-exception';

export class Color {

    a: number;
    b: number;
    g: number;
    r: number;

    static createColor(r: number, g: number, b: number, a: number): Color {

        if (Color.isInvalidRGBValue(r) ||
            Color.isInvalidRGBValue(g) ||
            Color.isInvalidRGBValue(b) ||
            Color.isInvalidTransparencyValue(a)
        ) {
            console.error('Invalid color');
            throw new InvalidColorException('The color is invalid');
        }

        const color: Color = new Color();
        color.r = r;
        color.g = g;
        color.b = b;
        color.a = a;

        return color;
    }

    private static isInvalidRGBValue(rgbValue: number): boolean {
        return rgbValue < 0 && rgbValue > 255;
    }

    private static isInvalidTransparencyValue(transparencyValue: number): boolean {
        return transparencyValue < 0 && transparencyValue > 1;
    }

    getColorString(ignoreTransparency?: boolean): string | undefined {
        if (!ignoreTransparency) {
            return `rgba(${this.r},${this.g},${this.b},${this.a})`;
        }

        return `rgb(${this.r},${this.g},${this.b})`;
    }

}
